module.exports = __webpack_public_path__ + "img/produkt-zeli-nalev.3f5222bc.jpg";